import { IconCheckDefault } from '@iwoca/icons';
import { Card } from '@iwoca/orion';
import clsx from 'clsx';
import { TFile } from 'components/Signup/hooks/useFileUploadReducer';
import { UploadedFiles } from 'components/UploadedFiles/UploadedFiles';
import FileUpIcon from 'svg/FileUpIcon';
import { TFileStatusGroup } from 'types';
import styles from './FileStatusGroup.module.css';
import { renderDocumentText } from './FileStatusGroupHelper';

type TProps = {
  files: TFile[];
  statusGroup: TFileStatusGroup;
  removeFile: (id: string) => void;
  testId?: string;
};

export const FileStatusGroup = ({
  files,
  statusGroup,
  removeFile,
  testId,
}: TProps) => {
  const filesToDisplay = files.filter((file) => {
    return file.statusGroup === statusGroup;
  });

  const renderStatusMessage = () => {
    return (
      <div className={styles.status}>
        {statusGroup === 'uploaded' ? (
          <FileUpIcon className={styles.icon} data-testid="uploaded-icon" />
        ) : statusGroup === 'approved' ? (
          <IconCheckDefault
            data-testid={`${statusGroup}-icon`}
            className={clsx(styles.icon, styles.approvedIcon)}
          />
        ) : (
          <IconCheckDefault
            data-testid={`${statusGroup}-icon`}
            className={clsx(styles.icon, styles.rejectedIcon)}
          />
        )}

        <p className={styles.statusText}>
          {renderDocumentText({ files, statusGroup })}
        </p>
      </div>
    );
  };

  if (filesToDisplay.length === 0) {
    return null;
  }

  const dataTestId = `status-group${testId ? `-${testId}` : ''}`;

  return (
    <Card
      data-testid={dataTestId}
      className={clsx(styles.statusGroup, styles[statusGroup])}
    >
      <div className={styles.fileList}>
        <UploadedFiles files={filesToDisplay} removeFile={removeFile} />
      </div>
      {renderStatusMessage()}
    </Card>
  );
};
